<template>
  <LocationInput
    :searchResults="geoSearchResultList"
    :selectedLocation="location"
    :disabled="isLoading"
    :allowClear="allowClear"
    :noLabel="noLabel"
    :dropdownLayerSize="dropdownLayerSize"
    @onInputChange="handleSearchTextChange"
    @onSelectedLocationChange="handleSelectedLocationChange"
    @onClearLocation="handleOnClearLocation"
  />
</template>
<script lang="ts" setup>
import { HgSupportedLanguage } from '@smg-real-estate/domus';
import { type GeoLocation } from '@smg-real-estate/geo-libs';
import { type GeoSearchResultItem } from '@smg-real-estate/geo-libs/dist/types/geo-api-responses';
import { storeToRefs } from 'pinia';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import { fetchGeoLocations } from '@/api/geoService';
import LocationInput from '@/components/search-bar/address-search/LocationInput.vue';
import useMapStore from '@/stores/useMapStore';
import { ENABLED_GEO_LEVELS } from '@/types';

interface Props {
  location: GeoLocation | null;
  allowClear?: boolean;
  noLabel?: boolean;
  dropdownLayerSize?: 'small' | 'medium';
}
withDefaults(defineProps<Props>(), {
  allowClear: false,
  noLabel: false,
  dropdownLayerSize: 'medium',
});
const geoSearchResultList = ref<GeoSearchResultItem[]>([]);
const { locale } = useI18n();
const emit = defineEmits<{
  // TODO find the lint rule to match the Composition API
  /* eslint-disable unused-imports/no-unused-vars */
  (e: 'onSelectedLocationChange', location: GeoLocation): void;
  (e: 'onClearLocation'): void;
}>();
const handleSelectedLocationChange = (value: GeoLocation): void => {
  emit('onSelectedLocationChange', value);
};
const handleOnClearLocation = (): void => {
  emit('onClearLocation');
};
const handleSearchTextChange = async (searchText: string): Promise<void> => {
  geoSearchResultList.value = (
    await fetchGeoLocations(searchText, locale.value as HgSupportedLanguage)
  ).filter((item) => ENABLED_GEO_LEVELS.indexOf(item.geoLocation.type) > -1);
};

const { isLoading } = storeToRefs(useMapStore());
</script>
